(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/single-rows/betslip-singlerows.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/single-rows/betslip-singlerows.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.BetslipSingleboardsCoupon = Marionette.View.extend({
    modelEvents: {
      change: 'render'
    },
    template: function(data) {
      return svs.tipset.templates.betslip_singlerows(data);
    },

    log: new svs.core.log.Logger('svs.tipset.views.BetslipSingleboardsCoupon'),

    className: 'betslip-singlerows',

    initialize: function() {
      this.log.debug('initialize');
      this.uid = svs.tipset.getUid();
    },

    onRender: function() {
      svs.tipset.calls.addCall('betslip-singlerows ' + this.uid);
    },

    onDomRefresh: function() {
      this.trigger('changesize');
    }
  });
})(Backbone, _, svs);

 })(window);